import { render, staticRenderFns } from "./BookRule.vue?vue&type=template&id=3bffd732&scoped=true&"
import script from "./BookRule.vue?vue&type=script&lang=js&"
export * from "./BookRule.vue?vue&type=script&lang=js&"
import style0 from "./BookRule.vue?vue&type=style&index=0&id=3bffd732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bffd732",
  null
  
)

export default component.exports